import {
  PULSE_CLICK_ACTION,
  PULSE_CLICK_CATEGORY,
  trackPulseClick,
} from './pulseClickIds';

/** Mobile hamburger sidebar taps (profile links, contact us, etc.). */
export const trackHamburgerMenuClick = (
  action: string,
  page_path?: string
): void => {
  const path =
    page_path !== undefined
      ? page_path
      : typeof window !== 'undefined'
        ? window.location.pathname
        : undefined;

  trackPulseClick({
    category: PULSE_CLICK_CATEGORY.HAMBURGER_MENU,
    action,
    label: null,
    view_id: 'hamburger_menu',
    page_id: PULSE_CLICK_CATEGORY.HAMBURGER_MENU,
    page_path: path,
  });
};

export const trackHamburgerProfilePreferencesClick = (page_path?: string): void =>
  trackHamburgerMenuClick(PULSE_CLICK_ACTION.TAP_PROFILE_PREFERENCES, page_path);

export const trackHamburgerLoyaltyRewardsClick = (page_path?: string): void =>
  trackHamburgerMenuClick(PULSE_CLICK_ACTION.TAP_LOYALTY_REWARDS, page_path);

export const trackHamburgerRewardsFaqClick = (page_path?: string): void =>
  trackHamburgerMenuClick(PULSE_CLICK_ACTION.TAP_REWARDS_FAQ, page_path);

export const trackHamburgerContactUsClick = (page_path?: string): void =>
  trackHamburgerMenuClick(PULSE_CLICK_ACTION.TAP_CONTACT_US, page_path);
